import {
  AppTranslatorAfghanistanMulticolor,
  AppTranslatorAlbaniaMulticolor,
  AppTranslatorArmeniaMulticolor,
  AppTranslatorAustraliaMulticolor,
  AppTranslatorAzerbaijanMulticolor,
  AppTranslatorBangladeshMulticolor,
  AppTranslatorBelarusMulticolor,
  AppTranslatorBoliviaMulticolor,
  AppTranslatorBosniaAndHerzegovinaMulticolor,
  AppTranslatorBrazilMulticolor,
  AppTranslatorBulgariaMulticolor,
  AppTranslatorCambodiaMulticolor,
  AppTranslatorCanadaMulticolor,
  AppTranslatorChinaMulticolor,
  AppTranslatorCroatiaMulticolor,
  AppTranslatorCzechRepublicMulticolor,
  AppTranslatorDemocraticRepublicOfTheCongoMulticolor,
  AppTranslatorDenmarkMulticolor,
  AppTranslatorEgyptMulticolor,
  AppTranslatorEritreaMulticolor,
  AppTranslatorEstoniaMulticolor,
  AppTranslatorEthiopiaMulticolor,
  AppTranslatorFinlandMulticolor,
  AppTranslatorFranceMulticolor,
  AppTranslatorGeorgiaMulticolor,
  AppTranslatorGermanyMulticolor,
  AppTranslatorGhanaMulticolor,
  AppTranslatorGreeceMulticolor,
  AppTranslatorHaitiMulticolor,
  AppTranslatorHungaryMulticolor,
  AppTranslatorIcelandMulticolor,
  AppTranslatorIndiaMulticolor,
  AppTranslatorIndonesiaMulticolor,
  AppTranslatorIranMulticolor,
  AppTranslatorIraqMulticolor,
  AppTranslatorIrelandMulticolor,
  AppTranslatorIsraelMulticolor,
  AppTranslatorItalyMulticolor,
  AppTranslatorJapanMulticolor,
  AppTranslatorKazakhstanMulticolor,
  AppTranslatorKyrgyzstanMulticolor,
  AppTranslatorLaosMulticolor,
  AppTranslatorLatviaMulticolor,
  AppTranslatorLesothoMulticolor,
  AppTranslatorLithuaniaMulticolor,
  AppTranslatorLuxembourgMulticolor,
  AppTranslatorMadagascarMulticolor,
  AppTranslatorMalawiMulticolor,
  AppTranslatorMalaysiaMulticolor,
  AppTranslatorMaldivesMulticolor,
  AppTranslatorMaliMulticolor,
  AppTranslatorMaltaMulticolor,
  AppTranslatorMexicoMulticolor,
  AppTranslatorMongoliaMulticolor,
  AppTranslatorMyanmarMulticolor,
  AppTranslatorNepalMulticolor,
  AppTranslatorNetherlandsMulticolor,
  AppTranslatorNewZealandMulticolor,
  AppTranslatorNigeriaMulticolor,
  AppTranslatorNorthMacedoniaMulticolor,
  AppTranslatorNorwayMulticolor,
  AppTranslatorPakistanMulticolor,
  AppTranslatorParaguayMulticolor,
  AppTranslatorPeruMulticolor,
  AppTranslatorPhilippinesMulticolor,
  AppTranslatorPolandMulticolor,
  AppTranslatorPortugalMulticolor,
  AppTranslatorRomaniaMulticolor,
  AppTranslatorRussianFederationMulticolor,
  AppTranslatorRwandaMulticolor,
  AppTranslatorSamoaMulticolor,
  AppTranslatorSaudiArabiaMulticolor,
  AppTranslatorScotlandMulticolor,
  AppTranslatorSerbiaMulticolor,
  AppTranslatorSierraLeoneMulticolor,
  AppTranslatorSlovakiaMulticolor,
  AppTranslatorSloveniaMulticolor,
  AppTranslatorSomaliaMulticolor,
  AppTranslatorSouthAfricaMulticolor,
  AppTranslatorSouthKoreaMulticolor,
  AppTranslatorSpainMulticolor,
  AppTranslatorSriLankaMulticolor,
  AppTranslatorSwedenMulticolor,
  AppTranslatorTaiwanMulticolor,
  AppTranslatorTajikistanMulticolor,
  AppTranslatorTanzaniaMulticolor,
  AppTranslatorThailandMulticolor,
  AppTranslatorTogoMulticolor,
  AppTranslatorTurkeyMulticolor,
  AppTranslatorTurkmenistanMulticolor,
  AppTranslatorUgandaMulticolor,
  AppTranslatorUkraineMulticolor,
  AppTranslatorUnitedKingdomMulticolor,
  AppTranslatorUnitedStatesMulticolor,
  AppTranslatorUzbekistanMulticolor,
  AppTranslatorVietnamMulticolor,
  AppTranslatorWalesMulticolor,
  AppTranslatorZimbabweMulticolor
} from '@elfsight/icons';

export const LANGUAGES = {
  af: {
    name: 'Afrikaans',
    codeName: 'AF',
    originalName: 'Afrikaans',
    flag: AppTranslatorSouthAfricaMulticolor
  },
  sq: {
    name: 'Albanian',
    codeName: 'SQ',
    originalName: 'Shqip',
    flag: AppTranslatorAlbaniaMulticolor
  },
  am: {
    name: 'Amharic',
    codeName: 'AM',
    originalName: 'አማርኛ',
    flag: AppTranslatorEthiopiaMulticolor
  },
  'ar-SA': {
    name: 'Arabic',
    codeName: 'AR',
    originalName: 'العربية',
    flag: AppTranslatorSaudiArabiaMulticolor
  },
  'ar-EG': {
    name: 'Arabic',
    codeName: 'AR',
    originalName: 'العربية',
    flag: AppTranslatorEgyptMulticolor
  },
  hy: {
    name: 'Armenian',
    codeName: 'HY',
    originalName: 'Հայերեն',
    flag: AppTranslatorArmeniaMulticolor
  },
  as: {
    name: 'Assamese',
    codeName: 'AS',
    originalName: 'অসমীয়া',
    flag: AppTranslatorIndiaMulticolor
  },
  ay: {
    name: 'Aymara',
    codeName: 'AY',
    originalName: 'Aymar aru',
    flag: AppTranslatorBoliviaMulticolor
  },
  az: {
    name: 'Azerbaijani',
    codeName: 'AZ',
    originalName: 'Azərbaycan dili',
    flag: AppTranslatorAzerbaijanMulticolor
  },
  bm: {
    name: 'Bambara',
    codeName: 'BM',
    originalName: 'Bamanankan',
    flag: AppTranslatorMaliMulticolor
  },
  eu: {
    name: 'Basque',
    codeName: 'EU',
    originalName: 'Euskara',
    flag: AppTranslatorSpainMulticolor
  },
  be: {
    name: 'Belarusian',
    codeName: 'BE',
    originalName: 'Беларуская',
    flag: AppTranslatorBelarusMulticolor
  },
  bn: {
    name: 'Bengali',
    codeName: 'BN',
    originalName: 'বাংলা',
    flag: AppTranslatorBangladeshMulticolor
  },
  bho: {
    name: 'Bhojpuri',
    codeName: 'BHO',
    originalName: 'भोजपुरी',
    flag: AppTranslatorIndiaMulticolor
  },
  bs: {
    name: 'Bosnian',
    codeName: 'BS',
    originalName: 'Bosanski',
    flag: AppTranslatorBosniaAndHerzegovinaMulticolor
  },
  bg: {
    name: 'Bulgarian',
    codeName: 'BG',
    originalName: 'Български',
    flag: AppTranslatorBulgariaMulticolor
  },
  ca: {
    name: 'Catalan',
    codeName: 'CA',
    originalName: 'Català',
    flag: AppTranslatorSpainMulticolor
  },
  ceb: {
    name: 'Cebuano',
    codeName: 'CEB',
    originalName: 'Sinugboanon',
    flag: AppTranslatorPhilippinesMulticolor
  },
  ny: {
    name: 'Chichewa',
    codeName: 'NY',
    originalName: 'Chichewa',
    flag: AppTranslatorMalawiMulticolor
  },
  'zh-cn': {
    name: 'Chinese Simplified',
    codeName: 'ZH-CN',
    originalName: '汉语',
    flag: AppTranslatorChinaMulticolor
  },
  'zh-tw': {
    name: 'Chinese Traditional',
    codeName: 'ZH-TW',
    originalName: '中文',
    flag: AppTranslatorTaiwanMulticolor
  },
  co: {
    name: 'Corsican',
    codeName: 'CO',
    originalName: 'Corsu',
    flag: AppTranslatorFranceMulticolor
  },
  hr: {
    name: 'Croatian',
    codeName: 'HR',
    originalName: 'Hrvatski',
    flag: AppTranslatorCroatiaMulticolor
  },
  cs: {
    name: 'Czech',
    codeName: 'CS',
    originalName: 'Čeština',
    flag: AppTranslatorCzechRepublicMulticolor
  },
  da: {
    name: 'Danish',
    codeName: 'DA',
    originalName: 'Dansk',
    flag: AppTranslatorDenmarkMulticolor
  },
  'fa-AF': {
    name: 'Dari',
    codeName: 'FA',
    originalName: 'دری',
    flag: AppTranslatorAfghanistanMulticolor
  },
  dv: {
    name: 'Dhivehi',
    codeName: 'DV',
    originalName: 'ދިވެހި',
    flag: AppTranslatorMaldivesMulticolor
  },
  doi: {
    name: 'Dogri',
    codeName: 'DOI',
    originalName: 'डोगरी',
    flag: AppTranslatorIndiaMulticolor
  },
  nl: {
    name: 'Dutch',
    codeName: 'NL',
    originalName: 'Nederlands',
    flag: AppTranslatorNetherlandsMulticolor
  },
  'en-GB': {
    name: 'English',
    codeName: 'EN',
    originalName: 'English',
    flag: AppTranslatorUnitedKingdomMulticolor
  },
  'en-US': {
    name: 'English',
    codeName: 'EN',
    originalName: 'English',
    flag: AppTranslatorUnitedStatesMulticolor
  },
  'en-CA': {
    name: 'English',
    codeName: 'EN',
    originalName: 'English',
    flag: AppTranslatorCanadaMulticolor
  },
  'en-AU': {
    name: 'English',
    codeName: 'EN',
    originalName: 'English',
    flag: AppTranslatorAustraliaMulticolor
  },
  et: {
    name: 'Estonian',
    codeName: 'ET',
    originalName: 'Eesti',
    flag: AppTranslatorEstoniaMulticolor
  },
  ee: {
    name: 'Ewe',
    codeName: 'EE',
    originalName: 'Eʋegbe',
    flag: AppTranslatorTogoMulticolor
  },
  tl: {
    name: 'Filipino',
    codeName: 'TL',
    originalName: 'Filipino',
    flag: AppTranslatorPhilippinesMulticolor
  },
  fi: {
    name: 'Finnish',
    codeName: 'FI',
    originalName: 'Suomi',
    flag: AppTranslatorFinlandMulticolor
  },
  fr: {
    name: 'French',
    codeName: 'FR',
    originalName: 'Français',
    flag: AppTranslatorFranceMulticolor
  },
  fy: {
    name: 'Frisian',
    codeName: 'FY',
    originalName: 'Frysk',
    flag: AppTranslatorNetherlandsMulticolor
  },
  gl: {
    name: 'Galician',
    codeName: 'GL',
    originalName: 'Galego',
    flag: AppTranslatorSpainMulticolor
  },
  ka: {
    name: 'Georgian',
    codeName: 'KA',
    originalName: 'ქართული',
    flag: AppTranslatorGeorgiaMulticolor
  },
  de: {
    name: 'German',
    codeName: 'DE',
    originalName: 'Deutsch',
    flag: AppTranslatorGermanyMulticolor
  },
  el: {
    name: 'Greek',
    codeName: 'EL',
    originalName: 'Ελληνικά',
    flag: AppTranslatorGreeceMulticolor
  },
  gn: {
    name: 'Guarani',
    codeName: 'GN',
    originalName: "Avañe'ẽ",
    flag: AppTranslatorParaguayMulticolor
  },
  gu: {
    name: 'Gujarati',
    codeName: 'GU',
    originalName: 'ગુજરાતી',
    flag: AppTranslatorIndiaMulticolor
  },
  ht: {
    name: 'Haitian Creole',
    codeName: 'HT',
    originalName: 'Kreyòl Ayisyen',
    flag: AppTranslatorHaitiMulticolor
  },
  ha: {
    name: 'Hausa',
    codeName: 'HA',
    originalName: 'Harshen Hausa',
    flag: AppTranslatorNigeriaMulticolor
  },
  haw: {
    name: 'Hawaiian',
    codeName: 'HAW',
    originalName: 'ʻŌlelo Hawaiʻi',
    flag: AppTranslatorUnitedStatesMulticolor
  },
  iw: {
    name: 'Hebrew',
    codeName: 'IW',
    originalName: 'עברית',
    flag: AppTranslatorIsraelMulticolor
  },
  hi: {
    name: 'Hindi',
    codeName: 'HI',
    originalName: 'हिन्दी',
    flag: AppTranslatorIndiaMulticolor
  },
  hmn: {
    name: 'Hmong',
    codeName: 'HMN',
    originalName: 'Hmoob',
    flag: AppTranslatorLaosMulticolor
  },
  hu: {
    name: 'Hungarian',
    codeName: 'HU',
    originalName: 'Magyar',
    flag: AppTranslatorHungaryMulticolor
  },
  is: {
    name: 'Icelandic',
    codeName: 'IS',
    originalName: 'Íslenska',
    flag: AppTranslatorIcelandMulticolor
  },
  ig: {
    name: 'Igbo',
    codeName: 'IG',
    originalName: 'Asụsụ Igbo',
    flag: AppTranslatorNigeriaMulticolor
  },
  ilo: {
    name: 'Ilocano',
    codeName: 'ILO',
    originalName: 'Ilocano',
    flag: AppTranslatorPhilippinesMulticolor
  },
  'id-id': {
    name: 'Indonesian',
    codeName: 'ID',
    originalName: 'Bahasa Indonesia',
    flag: AppTranslatorIndonesiaMulticolor
  },
  ga: {
    name: 'Irish',
    codeName: 'GA',
    originalName: 'Gaeilge',
    flag: AppTranslatorIrelandMulticolor
  },
  it: {
    name: 'Italian',
    codeName: 'IT',
    originalName: 'Italiano',
    flag: AppTranslatorItalyMulticolor
  },
  ja: {
    name: 'Japanese',
    codeName: 'JA',
    originalName: '日本語',
    flag: AppTranslatorJapanMulticolor
  },
  jw: {
    name: 'Javanese',
    codeName: 'JW',
    originalName: 'ꦧꦱꦗꦮ',
    flag: AppTranslatorIndonesiaMulticolor
  },
  kn: {
    name: 'Kannada',
    codeName: 'KN',
    originalName: 'ಕನ್ನಡ',
    flag: AppTranslatorIndiaMulticolor
  },
  kk: {
    name: 'Kazakh',
    codeName: 'KK',
    originalName: 'Қазақша',
    flag: AppTranslatorKazakhstanMulticolor
  },
  km: {
    name: 'Khmer',
    codeName: 'KM',
    originalName: 'ភាសាខ្មែរ',
    flag: AppTranslatorCambodiaMulticolor
  },
  rw: {
    name: 'Kinyarwanda',
    codeName: 'RW',
    originalName: 'Ikinyarwanda',
    flag: AppTranslatorRwandaMulticolor
  },
  gom: {
    name: 'Konkani',
    codeName: 'GOM',
    originalName: 'कोंकणी',
    flag: AppTranslatorIndiaMulticolor
  },
  ko: {
    name: 'Korean',
    codeName: 'KO',
    originalName: '한국어',
    flag: AppTranslatorSouthKoreaMulticolor
  },
  kr: {
    name: 'Krio',
    codeName: 'KR',
    originalName: 'Krio',
    flag: AppTranslatorSierraLeoneMulticolor
  },
  ku: {
    name: 'Kurdish Kurmanji',
    codeName: 'KU',
    originalName: 'Kurmancî',
    flag: AppTranslatorTurkeyMulticolor
  },
  ckb: {
    name: 'Kurdish Sorani',
    codeName: 'CKB',
    originalName: 'کوردی سورانی',
    flag: AppTranslatorIraqMulticolor
  },
  ky: {
    name: 'Kyrgyz',
    codeName: 'KY',
    originalName: 'Кыргызча',
    flag: AppTranslatorKyrgyzstanMulticolor
  },
  lo: {
    name: 'Lao',
    codeName: 'LO',
    originalName: 'ພາສາລາວ',
    flag: AppTranslatorLaosMulticolor
  },
  lv: {
    name: 'Latvian',
    codeName: 'LV',
    originalName: 'Latviešu valoda',
    flag: AppTranslatorLatviaMulticolor
  },
  ln: {
    name: 'Lingala',
    codeName: 'LN',
    originalName: 'Lingála',
    flag: AppTranslatorDemocraticRepublicOfTheCongoMulticolor
  },
  lt: {
    name: 'Lithuanian',
    codeName: 'LT',
    originalName: 'Lietuvių',
    flag: AppTranslatorLithuaniaMulticolor
  },
  lg: {
    name: 'Luganda',
    codeName: 'LG',
    originalName: 'Luganda',
    flag: AppTranslatorUgandaMulticolor
  },
  lb: {
    name: 'Luxembourgish',
    codeName: 'LB',
    originalName: 'Lëtzebuergesch',
    flag: AppTranslatorLuxembourgMulticolor
  },
  mk: {
    name: 'Macedonian',
    codeName: 'MK',
    originalName: 'Македонски',
    flag: AppTranslatorNorthMacedoniaMulticolor
  },
  mai: {
    name: 'Maithili',
    codeName: 'MAI',
    originalName: 'मैथिली',
    flag: AppTranslatorIndiaMulticolor
  },
  mg: {
    name: 'Malagasy',
    codeName: 'MG',
    originalName: 'Malagasy',
    flag: AppTranslatorMadagascarMulticolor
  },
  ms: {
    name: 'Malay',
    codeName: 'MS',
    originalName: 'Bahasa Melayu',
    flag: AppTranslatorMalaysiaMulticolor
  },
  ml: {
    name: 'Malayalam',
    codeName: 'ML',
    originalName: 'മലയാളം',
    flag: AppTranslatorIndiaMulticolor
  },
  mt: {
    name: 'Maltese',
    codeName: 'MT',
    originalName: 'Malti',
    flag: AppTranslatorMaltaMulticolor
  },
  mi: {
    name: 'Maori',
    codeName: 'MI',
    originalName: 'Te Reo Māori',
    flag: AppTranslatorNewZealandMulticolor
  },
  mr: {
    name: 'Marathi',
    codeName: 'MR',
    originalName: 'मराठी',
    flag: AppTranslatorIndiaMulticolor
  },
  'mni-mtei': {
    name: 'Meiteilon Manipuri',
    codeName: 'MNI-MTEI',
    originalName: 'মৈতৈলোন',
    flag: AppTranslatorIndiaMulticolor
  },
  lus: {
    name: 'Mizo',
    codeName: 'LUS',
    originalName: 'Mizo ţawng',
    flag: AppTranslatorIndiaMulticolor
  },
  mn: {
    name: 'Mongolian',
    codeName: 'MN',
    originalName: 'Монгол',
    flag: AppTranslatorMongoliaMulticolor
  },
  my: {
    name: 'Myanmar',
    codeName: 'MY',
    originalName: 'မြန်မာဘာသာ',
    flag: AppTranslatorMyanmarMulticolor
  },
  ne: {
    name: 'Nepali',
    codeName: 'NE',
    originalName: 'नेपाली',
    flag: AppTranslatorNepalMulticolor
  },
  no: {
    name: 'Norwegian',
    codeName: 'NO',
    originalName: 'Norsk',
    flag: AppTranslatorNorwayMulticolor
  },
  or: {
    name: 'Odia',
    codeName: 'OR',
    originalName: 'ଓଡ଼ିଆ',
    flag: AppTranslatorIndiaMulticolor
  },
  om: {
    name: 'Oromo',
    codeName: 'OM',
    originalName: 'Afaan Oromoo',
    flag: AppTranslatorEthiopiaMulticolor
  },
  ps: {
    name: 'Pashto',
    codeName: 'PS',
    originalName: 'پښتو',
    flag: AppTranslatorAfghanistanMulticolor
  },
  'fa-IR': {
    name: 'Persian',
    codeName: 'FA',
    originalName: 'فارسی',
    flag: AppTranslatorIranMulticolor
  },
  pl: {
    name: 'Polish',
    codeName: 'PL',
    originalName: 'Polski',
    flag: AppTranslatorPolandMulticolor
  },
  'pt-PT': {
    name: 'Portuguese',
    codeName: 'PT',
    originalName: 'Português',
    flag: AppTranslatorPortugalMulticolor
  },
  'pt-BR': {
    name: 'Portuguese',
    codeName: 'PT',
    originalName: 'Português',
    flag: AppTranslatorBrazilMulticolor
  },
  pa: {
    name: 'Punjabi',
    codeName: 'PA',
    originalName: 'ਪੰਜਾਬੀ',
    flag: AppTranslatorIndiaMulticolor
  },
  qu: {
    name: 'Quechua',
    codeName: 'QU',
    originalName: 'Runa Simi',
    flag: AppTranslatorPeruMulticolor
  },
  ro: {
    name: 'Romanian',
    codeName: 'RO',
    originalName: 'Română',
    flag: AppTranslatorRomaniaMulticolor
  },
  ru: {
    name: 'Russian',
    codeName: 'RU',
    originalName: 'Русский',
    flag: AppTranslatorRussianFederationMulticolor
  },
  sm: {
    name: 'Samoan',
    codeName: 'SM',
    originalName: 'Gagana Samoa',
    flag: AppTranslatorSamoaMulticolor
  },
  sa: {
    name: 'Sanskrit',
    codeName: 'SA',
    originalName: 'संस्कृतम्',
    flag: AppTranslatorIndiaMulticolor
  },
  gd: {
    name: 'Scottish Gaelic',
    codeName: 'GD',
    originalName: 'Gàidhlig',
    flag: AppTranslatorScotlandMulticolor
  },
  nso: {
    name: 'Sepedi',
    codeName: 'NSO',
    originalName: 'Sepedi',
    flag: AppTranslatorSouthAfricaMulticolor
  },
  sr: {
    name: 'Serbian',
    codeName: 'SR',
    originalName: 'Српски',
    flag: AppTranslatorSerbiaMulticolor
  },
  st: {
    name: 'Sesotho',
    codeName: 'ST',
    originalName: 'Sesotho',
    flag: AppTranslatorLesothoMulticolor
  },
  sn: {
    name: 'Shona',
    codeName: 'SN',
    originalName: 'ChiShona',
    flag: AppTranslatorZimbabweMulticolor
  },
  sd: {
    name: 'Sindhi',
    codeName: 'SD',
    originalName: 'سنڌي',
    flag: AppTranslatorPakistanMulticolor
  },
  si: {
    name: 'Sinhala',
    codeName: 'SI',
    originalName: 'සිංහල',
    flag: AppTranslatorSriLankaMulticolor
  },
  sk: {
    name: 'Slovak',
    codeName: 'SK',
    originalName: 'Slovenčina',
    flag: AppTranslatorSlovakiaMulticolor
  },
  sl: {
    name: 'Slovenian',
    codeName: 'SL',
    originalName: 'Slovenščina',
    flag: AppTranslatorSloveniaMulticolor
  },
  so: {
    name: 'Somali',
    codeName: 'SO',
    originalName: 'Soomaaliga',
    flag: AppTranslatorSomaliaMulticolor
  },
  'es-ES': {
    name: 'Spanish',
    codeName: 'ES',
    originalName: 'Español',
    flag: AppTranslatorSpainMulticolor
  },
  'es-MX': {
    name: 'Spanish',
    codeName: 'ES',
    originalName: 'Español',
    flag: AppTranslatorMexicoMulticolor
  },
  su: {
    name: 'Sundanese',
    codeName: 'SU',
    originalName: 'Basa Sunda',
    flag: AppTranslatorIndonesiaMulticolor
  },
  sw: {
    name: 'Swahili',
    codeName: 'SW',
    originalName: 'Kiswahili',
    flag: AppTranslatorTanzaniaMulticolor
  },
  sv: {
    name: 'Swedish',
    codeName: 'SV',
    originalName: 'Svenska',
    flag: AppTranslatorSwedenMulticolor
  },
  tg: {
    name: 'Tajik',
    codeName: 'TG',
    originalName: 'тоҷикӣ',
    flag: AppTranslatorTajikistanMulticolor
  },
  ta: {
    name: 'Tamil',
    codeName: 'TA',
    originalName: 'தமிழ்',
    flag: AppTranslatorSriLankaMulticolor
  },
  tt: {
    name: 'Tatar',
    codeName: 'TT',
    originalName: 'Татарча',
    flag: AppTranslatorRussianFederationMulticolor
  },
  te: {
    name: 'Telugu',
    codeName: 'TE',
    originalName: 'తెలుగు',
    flag: AppTranslatorIndiaMulticolor
  },
  th: {
    name: 'Thai',
    codeName: 'TH',
    originalName: 'ไทย',
    flag: AppTranslatorThailandMulticolor
  },
  ti: {
    name: 'Tigrinya',
    codeName: 'TI',
    originalName: 'ትግርኛ',
    flag: AppTranslatorEritreaMulticolor
  },
  ts: {
    name: 'Tsonga',
    codeName: 'TS',
    originalName: 'Xitsonga',
    flag: AppTranslatorSouthAfricaMulticolor
  },
  tr: {
    name: 'Turkish',
    codeName: 'TR',
    originalName: 'Türkçe',
    flag: AppTranslatorTurkeyMulticolor
  },
  tk: {
    name: 'Turkmen',
    codeName: 'TK',
    originalName: 'Türkmençe',
    flag: AppTranslatorTurkmenistanMulticolor
  },
  ak: {
    name: 'Twi',
    codeName: 'AK',
    originalName: 'Twi',
    flag: AppTranslatorGhanaMulticolor
  },
  uk: {
    name: 'Ukrainian',
    codeName: 'UK',
    originalName: 'Українська',
    flag: AppTranslatorUkraineMulticolor
  },
  ur: {
    name: 'Urdu',
    codeName: 'UR',
    originalName: 'اردو',
    flag: AppTranslatorPakistanMulticolor
  },
  ug: {
    name: 'Uyghur',
    codeName: 'UG',
    originalName: 'ئۇيغۇرچە',
    flag: AppTranslatorChinaMulticolor
  },
  uz: {
    name: 'Uzbek',
    codeName: 'UZ',
    originalName: 'Oʻzbekcha',
    flag: AppTranslatorUzbekistanMulticolor
  },
  vi: {
    name: 'Vietnamese',
    codeName: 'VI',
    originalName: 'Tiếng Việt',
    flag: AppTranslatorVietnamMulticolor
  },
  cy: {
    name: 'Welsh',
    codeName: 'CY',
    originalName: 'Cymraeg',
    flag: AppTranslatorWalesMulticolor
  },
  xh: {
    name: 'Xhosa',
    codeName: 'XH',
    originalName: 'isiXhosa',
    flag: AppTranslatorSouthAfricaMulticolor
  },
  yi: {
    name: 'Yiddish',
    codeName: 'YI',
    originalName: 'ייִדיש',
    flag: AppTranslatorIsraelMulticolor
  },
  yo: {
    name: 'Yoruba',
    codeName: 'YO',
    originalName: 'Yorùbá',
    flag: AppTranslatorNigeriaMulticolor
  },
  zu: {
    name: 'Zulu',
    codeName: 'ZU',
    originalName: 'isiZulu',
    flag: AppTranslatorSouthAfricaMulticolor
  }
} as const;
